// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRippleModule } from '@angular/material/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';

import { ScrollingModule } from '@angular/cdk/scrolling';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';


import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { NgxComponentsLibModule } from '@nextgen/components-lib';

// import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';


// import { HttpModule } from '@angular/http';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgModule } from '@angular/core';
import { TableDirective } from './shared/directives/table.directive';
// import { GenericPopupComponent } from './generic-popup/generic-popup.component';

// import { PdfViewerModule } from 'ng2-pdf-viewer';


@NgModule({ exports: [
        // BrowserAnimationsModule,
        DragDropModule,
        OverlayModule,
        MatTabsModule,
        MatRadioModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        MatInputModule,
        MatFormFieldModule,
        MatDialogModule,
        MatTableModule,
        MatCheckboxModule,
        MatPaginatorModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatIconModule,
        MatSortModule,
        MatSidenavModule,
        MatSelectModule,
        TableDirective,
        MatTooltipModule,
        MatCardModule,
        // HttpModule,
        // HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        ScrollingModule,
        MatRippleModule,
        MatToolbarModule,
        MatButtonModule,
        MatExpansionModule,
        // imported library components
        NgxComponentsLibModule,
        // Ng4LoadingSpinnerModule
        // outside modules
        // PdfViewerModule,
        
    ],
    declarations: [
        TableDirective,
        // GenericPopupComponent
    ], imports: [
        // BrowserAnimationsModule,
        DragDropModule,
        OverlayModule,
        MatTabsModule,
        MatRadioModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        MatInputModule,
        MatFormFieldModule,
        MatDialogModule,
        MatTableModule,
        MatCheckboxModule,
        MatPaginatorModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatIconModule,
        MatSortModule,
        MatSidenavModule,
        MatSelectModule,
        MatTooltipModule,
        MatCardModule,
        FormsModule,
        ReactiveFormsModule,
        ScrollingModule,
        MatRippleModule,
        MatToolbarModule,
        MatButtonModule,
        MatExpansionModule,
        // imported library components
        NgxComponentsLibModule,
        // Ng4LoadingSpinnerModule,
        // outside imports
        // PdfViewerModule,
        ], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class MaterialModule { }
